var text_field_default = {
  "root": "omn3b",
  "text": "kySwo",
  "input": "numE-",
  "small": "lGYO9",
  "medium": "cP-8u",
  "large": "uO-Hu",
  "webview": "dcIAv",
  "endAdornment": "rz7b4",
  "shown": "AZ2Nt",
  "value": "ieGx7",
  "spinner": "wtzvL",
  "spin": "FGlCG"
};
export {
  text_field_default as default
};
//# sourceMappingURL=text-field-scss.js.map
